import * as React from 'react';
import Select from '../Components/Select';
import TextInput from '../Components/TextInput';

export interface DonationTypeOption {
  id: string;
  name: string;
}

export interface Props {
  selectedOption: string;
  customValue: string;
  options: DonationTypeOption[];
  otherId: string;
  defaultId: string;

  setDonationTypeOption: (selectedOptionId: string) => void;
  setCustomEntry: (customValue: string) => void;
}

const unselected = '';

export default class DonationTypeModule extends React.Component<Props> {
  render() {
    return (
      <div className="input-field col s12 m12 undefined"><>
        <Select        
          value={this.props.selectedOption || unselected}
          onChange={this.onChange}
          
        >
          <option value={unselected}>Please select...</option>
          {this.props.options.map((option, index) => (
            <option value={option.id} key={index}>
              {option.name}
            </option>
          ))}
           {this.props.otherId && (<option value={this.props.otherId}>Other</option>)}
        </Select>
        <label>Reason for donating?</label>
        {this.props.otherId && this.props.selectedOption === this.props.otherId && (
          <TextInput
            label="Please let us know why you are donating?"
            id="donationType-other"
            value={this.props.customValue}
            onChange={this.onCustomChange}
          />
        )}
      </></div>
    );
  }

  private onChange = (option: string) => {
    this.props.setDonationTypeOption(option);
    const selectedOption = this.props.options.find((v) => v.id === option);
    if (selectedOption) {
      let text = selectedOption.name;
      this.props.setCustomEntry(text);
    }
  };

  private onCustomChange = (value: string) => {
    this.props.setCustomEntry(value);
  };
}



// WEBPACK FOOTER //
// ./src/Modules/DonationTypeModule.tsx